import { useCallback } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';

import { isCsatEligible } from '../utils/csat-eligibility-storage/isCsatEligible';
import { recordCsatDisplayed } from '../utils/csat-eligibility-storage/recordCsatDisplayed';
import { recordCsatInteracted } from '../utils/csat-eligibility-storage/recordCsatInteracted';

type UseCsatEligibilityParams = {
	enabled: boolean;
};

type UseCsatEligibilityResult = {
	isEligibleToShow: boolean;
	onCsatInteracted: () => void;
	onCsatDisplayed: () => void;
};

export const useCsatEligibility = ({
	enabled,
}: UseCsatEligibilityParams): UseCsatEligibilityResult => {
	const onCsatInteracted = useCallback(() => {
		recordCsatInteracted();
	}, []);
	const onCsatDisplayed = useCallback(() => {
		recordCsatDisplayed();
	}, []);

	if (!enabled) {
		return { isEligibleToShow: false, onCsatInteracted, onCsatDisplayed };
	}

	// QA escape hatch: bypasses experiment + cooldowns.
	const isForceShow = fg('rovo_chat_csat_survey_force_show');
	const passesPolicy = typeof window !== 'undefined' && isCsatEligible();

	let isEligibleToShow = false;
	if (isForceShow) {
		isEligibleToShow = true;
	} else if (passesPolicy) {
		isEligibleToShow = FeatureGates.getExperimentValue(
			'rovo_chat_csat_survey_feedback',
			'isEnabled',
			false,
		);
	}

	return { isEligibleToShow, onCsatInteracted, onCsatDisplayed };
};
